<template>
  <div class="side-cart-wrap">
    <div class="head">
      <div class="cart">
        Cart
        <span :class="showObject">Empty</span>
      </div>
    </div>
    <div class="empty" :class="showObject">
      <div class="img-wrap">
        <img src="../../assets/images/cart-empty.webp" alt="emptyCart" />
      </div>
      <div class="text-content">{{ getStaticAt(6, "en") }}</div>
    </div>
    <div class="cart-items-wrap" :class="showObject">
      <div class="cart-items">
        <div class="cart-item-content" v-for="item in cartItems" :key="item.id">
          <div class="item-info">
            <div class="food-name">{{ item.name }}</div>
          </div>
          <div class="price-info">
            <div class="order-button-wrap">
              <div class="added">
                <a-button
                  class="order-button minus"
                  icon="minus"
                  @click="minusQuantity(item.id)"
                />
                {{ item.quantity }}
                <a-button
                  class="order-button plus"
                  icon="plus"
                  @click="addQuantity(item.id)"
                />
              </div>
            </div>
            <div class="price">NRs {{ item.after_price }}</div>
            <div class="remove-item">
              <a-tooltip>
                <template slot="title">Remove item</template>
                <a-icon
                  type="delete"
                  style="color: red; cursor: pointer"
                  @click="deleteItem(item.id)"
                />
              </a-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="subtotal">
        <div class="total-price">
          <div class="text">Food Total</div>
          <div class="price">
            <span>NRs {{ this.cartTotal }}</span>
          </div>
        </div>
        <div class="total-price discount-info" v-if="showDiscount">
          <div class="text">Your Discount</div>
          <div class="discount">
            <span>- {{ this.getPromoDiscount }}%</span>
          </div>
        </div>
        <div class="total-price with-discount" v-if="showDiscount">
          <div class="text">New Total</div>
          <div class="price">
            <span>NRs {{ this.getPromoDiscountTotal }}</span>
          </div>
        </div>
        <div class="extra-charge">
          Plus Delivery Charges
          <br />Please select your location in next page.
        </div>

        <a-button type="primary" class="checkout-button" @click="onCheckout()"
          >Place Order →</a-button
        >
        <!-- <div class="checkout-button" @click="$emit('close-drawer')">Checkout →</div> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from "vuex";
import { CartData, LocationId } from "../../services/storage.service";
import router from "../../router";

export default {
  name: "Cart",
  data() {
    return {
      showDiscount: false,
    };
  },
  watch: {
    // whenever changes, this function will run
    cartItems: function (newCartItems, oldCartItems) {
      CartData.setCartItems(newCartItems);
    },

    getPromoDiscount: function (newDiscount, oldDiscount) {
      if (newDiscount > 0) {
        this.showDiscount = true;
      } else {
        this.showDiscount = false;
      }
    },
  },
  computed: {
    ...mapGetters([
      "cartTotal",
      "cartItems",
      "getPromoDiscountTotal",
      "getPromoDiscount",
      "systemStaticTexts",
    ]),
    showObject: function () {
      return {
        show: this.cartItems.length === 0,
      };
    },
  },
  methods: {
    ...mapActions([
      "addQuantity",
      "minusQuantity",
      "deleteItem",
      "addDiscount",
    ]),

    getStaticAt: function (id, ln) {
      // console.log(this.systemStaticTexts);

      let a = this.systemStaticTexts.filter((item) => item.id == id);
      // console.log(a);

      return a[0]["value_" + ln];
      // console.log(a);
    },

    onCheckout() {
      this.$emit("close-drawer");
      // router.push("/p/checkout");
      router.push("/p/order");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.head {
  .cart {
    span {
      display: none;
      &.show {
        display: inline-block;
      }
    }
  }
}
.empty {
  display: none;
  img {
    margin: 40px 0 40px 0;
    opacity: 0.5;
    width: 100%;
    height: 212px;
  }
  .text-content {
    font-family: $main-font;
    color: #93959f;
    font-size: 14px;
  }
  &.show {
    display: block;
  }
}
.cart-items-wrap {
  display: block;
  &.show {
    display: none;
  }
}
</style>